import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { clientApi } from "@/utils/api";
import { TApiRes } from "@/types/api";

export const verifyResetTokenApi = async (payload: TResetPasswordQuery): Promise<boolean> => {
  try {
    const {
      data: { data },
    } = await clientApi.post<TApiRes<boolean>>("/verify-reset-token", payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
